module.exports = __webpack_public_path__ + "img/Lapland_University_of_Applied_Sciences-300x79.3e883bf5.png";